var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"surveyBoxContainer"},[_c('h5',[_vm._v("\n      Q"+_vm._s(_vm.item.order)+". "+_vm._s(_vm.item.question)+" "+_vm._s(_vm.item.essential == 'Y' ? '' : '(선택)')+" \n    ")]),_c('div',{staticClass:"surveyBoxInput flex flexAlignS"},[_vm._v("\n      * 단답형은 통계 수치를 나타낼 수 없어 엑셀 다운로드하여 확인바랍니다.\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }